var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.showModal,"max-width":"600px"},on:{"input":_vm.updateShowModal}},[_c('v-card',[_c('v-card-text',[_vm._t("default")],2),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{staticStyle:{"color":"white"},attrs:{"color":"#FF0000"},on:{"click":_vm.closeModal}},[_vm._v(" Cerrar ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }